import { useEffect, useContext } from "react";
import { TranslationsContext } from "../../utils/TranslationsContext";
import { icons } from "../../constants";
import "../../styles/global.css";
import "./styles/styles.css";

const MessageAlert = ({
  id,
  message,
  type = "success",
  onClose,
  persistent = false,
}) => {
  const { t } = useContext(TranslationsContext);

  useEffect(() => {
    if (persistent) return;
    const timer = setTimeout(() => {
      onClose && onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [id, persistent, onClose]);

  return (
    <div
      className={`flex-direction-row items-start message-alert ${
        type === "error" ? "error" : ""
      } ${persistent ? "persistent" : ""}`}
    >
      <div
        className="message-line-left"
        style={{
          backgroundColor:
            type === "success" ? "var(--Green-2)" : "var(--Red-1)",
        }}
      ></div>
      <div className="flex-direction-column message-alert-center">
        <div className="width-100 flex-direction-row message-alert-icon-text">
          <div className="flex-direction-row items-center message-alert-img">
            <img
              src={type === "success" ? icons.successfully_added : icons.error}
              alt="icon"
            />
          </div>
          <div className="inria-sans-400 font-14 flex-direction-column  justify-center message-alert-text">
            <p>{message}</p>
          </div>
        </div>
        {!persistent && (
          <div className="width-100 message-alert-line-wrapper">
            <div
              className="message-alert-line-fill"
              style={{
                backgroundColor:
                  type === "success" ? "var(--Green-2)" : "var(--Red-1)",
              }}
            />
          </div>
        )}
      </div>
      <img
        className="message-alert-close"
        onClick={() => onClose && onClose()}
        src={icons.close_gray}
        width={18}
        height={18}
        alt="X"
      />
    </div>
  );
};

export default MessageAlert;
